import { render, staticRenderFns } from "./ssoKundreskontraMiniWidget.vue?vue&type=template&id=33e85469&"
import script from "./ssoKundreskontraMiniWidget.vue?vue&type=script&lang=js&"
export * from "./ssoKundreskontraMiniWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\TeamCity\\Edison.Sso\\Dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e85469')) {
      api.createRecord('33e85469', component.options)
    } else {
      api.reload('33e85469', component.options)
    }
    module.hot.accept("./ssoKundreskontraMiniWidget.vue?vue&type=template&id=33e85469&", function () {
      api.rerender('33e85469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "v-components/widgets/ssoKundreskontraMiniWidget.vue"
export default component.exports